module.exports = __webpack_public_path__ + "c1f150332ab888d141964cc487d5eb89.woff";